import { stateGo } from 'redux-ui-router';
import { selectHasWorkoutSubscription, selectSubscription } from 'logic/member';

import {
  fetchWorkoutCollections,
  selectWorkoutCollectionsPagination,
} from 'logic/workout';

export const workoutsHacks = {
  template: `
    <ui-view>
      <div class="py-3 py-md-4">
        <div class="container">
          <div class="row mb-2">
            <div class="col-md-6 pb-3"
              ng-repeat="item in $ctrl.pagination.result track by $index">
              <card-collection
                heading="item.title"
                description="item.strapLine"
                img="item.coverImageUrl.magazine"
                ng-click="$ctrl.onClick(item)">
              </card-collection>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <pagination-row
                on-update-param="$ctrl.onUpdatePage(value)"
                pagination="$ctrl.pagination">
              </pagination-row>
            </div>
          </div>
        </div>
      </div>
    </ui-view>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.pagination.page) {
          this.fetchWorkoutCollections(this.subscriptionId, this.page);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      onClick({ id }) {
        this.stateGo('workouts.hacks.exercises', { hackId: id });
      },

      onUpdatePage(page) {
        this.stateGo('workouts.hacks', { page });
      },

      mapState({ member, router, workout }) {
        const page = router.currentParams.page || 1;

        return {
          page,
          hasAccess: selectHasWorkoutSubscription(member),
          pagination: selectWorkoutCollectionsPagination(workout, page),
          subscriptionId: selectSubscription(member).id,
        };
      },

      mapDispatch() {
        return {
          fetchWorkoutCollections,
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Hacks.js